import { render, staticRenderFns } from "./Side.vue?vue&type=template&id=3968a0ed&scoped=true&"
var script = {}
import style0 from "./Side.vue?vue&type=style&index=0&id=3968a0ed&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3968a0ed",
  null
  
)

export default component.exports